import React from 'react'

// 
function SmallImage({src, name, is_border, width_px, height_px, onClick,}) {
  return (
    <img src={src} alt={name} onClick={onClick} className={`w-[${width_px}px] h-[${height_px}px] object-cover rounded-[10px] ${is_border ? 'border-2 border-gold' : "border-2 border-black"}`} />
  )
}

export default SmallImage